import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MailWarning, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuthStore } from "../stores/authStore";
import { getAuthClient } from "../api";

/**
 * Soft gate (hub#345): quando o e-mail do corretor logado ainda não foi confirmado,
 * mostra um aviso com botão de reenviar — sem bloquear o acesso. `=== false` evita
 * incomodar sessões legadas cujo flag ainda não veio do backend (undefined).
 */
export function EmailVerificationBanner() {
  const { t } = useTranslation("auth");
  const emailVerified = useAuthStore((s) => s.user?.emailVerified);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  if (emailVerified !== false) return null;

  async function resend() {
    setSending(true);
    try {
      await getAuthClient().resendVerificationEmail();
      setSent(true);
      toast.success(t("verifyEmail.resendDone"));
    } catch {
      toast.error(t("verifyEmail.resendError"));
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 border-b border-warning-soft bg-warning-soft/60 px-4 py-1.5 text-[12px] font-medium text-warning-ink">
      <MailWarning size={13} />
      <span>{t("verifyEmail.bannerText")}</span>
      <button
        type="button"
        onClick={resend}
        disabled={sending || sent}
        className="inline-flex items-center gap-1 font-semibold underline underline-offset-2 hover:opacity-80 disabled:opacity-60"
      >
        {sending && <Loader2 size={12} className="animate-spin" />}
        {sent ? t("verifyEmail.bannerSent") : t("verifyEmail.bannerResend")}
      </button>
    </div>
  );
}
